import { graphql } from '@mp/graphql/generated';
import { type ResultOf } from '@graphql-typed-document-node/core';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';

const CurrentUserGql = graphql(`
  query GetCurrentUserForMarketsStep {
    me {
      address_zip
      professional {
        markets {
          id
          state_id
          display_name
        }
      }
    }
  }
`);

type CurrentUserProps = ResultOf<typeof CurrentUserGql>;

export const useCurrentUserForMarketStep = () => {
  const { data: currentUserData, isLoading } = useGraphQLQuery<CurrentUserProps>({
    operationName: 'GetCurrentUserForMarketsStep',
    query: CurrentUserGql,
    variables: {},
  });
  const currentUser = currentUserData?.me;

  return { currentUser, isLoading };
};
